import asl from '../assets/img/pics/asl.jpeg'
import dr from '../assets/img/pics/dr.jpeg'
import lf from '../assets/img/pics/lf.jpeg'
import fcz from '../assets/img/pics/fcz.jpeg'
import atr from '../assets/img/pics/atr.jpeg'

// { name: "", profession: "", face: "https://", lattes: "https://", instagram: "", img: "" },
export default [
    { name: "Acauane Sehnem Lima", img: asl },
    { name: "Daniela Raldi", img: dr },
    { name: "Leandro Fortunato", img: lf },
    { name: "Prof. Adriano Tony Ramos", img: atr },
    { name: "Prof. Francielli Cordeiro Zimermann", img: fcz },
]